module.exports = "<simple-notifications [options]=\"notifyOptions\"></simple-notifications>\n<div class=\"card\">\n    <div class=\"card-block\">\n        Notes Addition\n    </div>\n    <div class=\"card-footer\" style=\"padding:5px\">\n        <a class=\"btn btn-secondary pull-right\" (click)=\"showNewModal()\">Add Note</a>\n\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.html
// module id = ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.html
// module chunks = main